import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import img from "../Images/Jayraj_logo.png"
import "../Styles/TourOverview.css";
import {
  FaCalendarAlt,
  FaClock,
  FaChevronDown,
  FaChevronUp,
} from "react-icons/fa";
import Navber from "./Navber";
import Building from "../Images/Building.png";
import Van from "../Images/Van.png";
import Cablecar from "../Images/CableCar.png";
import NavigationArrow from "../Images/NavigationArrow.png";
import Travelers_favorite from "./Travelers_favorite";
import User_Destinations from "./User_Destinations";
import Typemsg from "./Typemsg";
import Why_travel_with_us from "./Why_travel_with_us";
import api from "../Api.js";
import Slider from "react-slick";
import DOMPurify from "dompurify";
import SafeMap from "./Safemap.jsx";
import { FormControl, InputLabel, Select } from '@mui/material'
import {
  Modal,
  Backdrop,
  Fade,
  Box,
  Button,
  IconButton,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  Snackbar,
  Alert,
  TextField,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { showToast } from "../Components/PopupMessage.jsx";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar, PickersDay } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { styled } from "@mui/material/styles";

import { useContext } from "react";
import { BookmarkedContext } from "../Context/BookmarkedContext.jsx";

function SafeComponent({ html }) {
  const cleanHTML = DOMPurify.sanitize(html);
  return <div dangerouslySetInnerHTML={{ __html: cleanHTML }} />;
}





const CustomDay = styled(PickersDay, {
  shouldForwardProp: (prop) => prop !== "isAvailable" && prop !== "isSelected",
})(({ theme, isAvailable, isSelected }) => ({
  borderRadius: "50%",

  ...(isAvailable && {
    "&::after": {
      content: '""',
      width: 6,
      height: 6,
      borderRadius: "50%",
      backgroundColor: "green",
      position: "absolute",
      bottom: 4,
    },
  }),

  ...(isSelected && {
    backgroundColor: "green !important",
    color: "white !important",
  }),
}));




const TourOverview = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(null);
  const [tourData, setTourData] = useState({});
  const [activities, setActivities] = useState([]);
  const [tourImages, setTourImages] = useState([]);
  const [tourVideos, setTourVideos] = useState([]);
  const [itininerary, setItinerary] = useState([]);
  const [showPrice, setShowPrice] = useState(false);
  const [totalPrice, setTotalPrice] = useState(0);
  const accessToken = localStorage.getItem("accessToken");
  const customer_data = JSON.parse(localStorage.getItem("customer"));
  const [tourOnlyPrice, setTourOnlyPrice] = useState(0);
 const [groupDepartureDates, setGroupDepartureDates] = useState([]);
 const [packageType, setPackageType] = useState("basic");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [travellers, setTravellers] = useState([{ name: "", age: "", type: "adult" }]);
  const { addBookmark, removeBookmark, isBookmarked, bookmarkedItems } = useContext(BookmarkedContext);
  const [selectedDate, setSelectedDate] = useState(null);
const availableDates = tourData?.dates?.group?.departure_dates || [];
const [transportData, setTransportData] = useState([]);
  const [showAll, setShowAll] = useState(false);



  console.log("customer data", customer_data)

  const toggleDay = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

// Toggle selected dates (add/remove)
const handleDateSelect = (date) => {
  const formatted = dayjs(date).format("YYYY-MM-DD");

  setGroupDepartureDates((prev) => {
    if (prev.includes(formatted)) {
      return prev.filter((d) => d !== formatted);
    } else {
      return [...prev, formatted];
    }
  });
};



  function calculateNights(checkIn, checkOut) {
    if (!checkIn || !checkOut) return 0;
    const inDate = new Date(checkIn);
    const outDate = new Date(checkOut);
    const diffTime = outDate.getTime() - inDate.getTime();
    const nights = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    return nights + 1;
  }

  useEffect(() => {
    const handleTourOverview = async () => {
      try {
        const response = await api.get(`/tours/${id}/details`);
        if (response?.data?.success === true) {
          setItinerary(response?.data?.data?.itineraries || []);
          setTourData(response?.data?.data?.tour);
          setActivities(response?.data?.data?.tour?.activities || []);
          setTotalPrice(
            response?.data?.data?.tour?.pricing?.stored_totals?.total_price_basic ||  tourData?.pricing?.per_person?.adult
          );
          setTourImages(response?.data?.data?.photos || []);
          setTourVideos(response?.data?.data?.videos?.[0] || []);
        }
      } catch (error) {
        console.error("Error fetching tour data: ", error);
      }
    };
    handleTourOverview();
  }, [id]);


  useEffect(() => {
    const fetchTransportOptions = async () => {
      try {
        const res = await api.get(`/transports`);
        console.log("Transport options response:", res.data);
        if (res?.data?.success) {
          setTransportData(res?.data?.data || []);
        }
      } catch (error) {
        console.error("Error fetching transport options:", error);
      }
    };
    fetchTransportOptions();

  }, []);

  const visibleCards = showAll ? transportData : transportData.slice(4, 8);

  const handleCheck = (id) => {
    setTransportData(prev =>
      prev.map(item =>
        item.id === id ? { ...item, checked: !item.checked } : item
      )
    );
  };


  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "none", background: "red" }}
        onClick={onClick}
      />
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "none", background: "green" }}
        onClick={onClick}
      />
    );
  }

  const settings = {
    customPaging: function (i) {
      return (
        <a>
          <img
            src={tourData?.destination?.gallery_photos[i]}
            alt={`thumb-${i}`}
            className="carousel-thumbnail"
          />
        </a>
      );
    },
    dots: true,
    dotsClass: "slick-dots slick-thumb",
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    fade: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />
  };

  const handleClose = () => setShowPrice(false);

  const handleTravellerChange = (index, field, value) => {
    const updated = [...travellers];
    updated[index][field] = value;
    setTravellers(updated);
  };

  const handleAddTraveller = () => {
    setTravellers([...travellers, { name: "", age: "", type: "adult" }]);
  };

  const handleRemoveTraveller = (index) => {
    setTravellers(travellers.filter((_, i) => i !== index));
  };


  




 // 🔥 STEP 1 — SELECT BASE PRICE FROM tourData ACCORDING TO PACKAGE TYPE
const getBasePrice = () => {
  if (!tourData?.pricing) return 0;

  const perPerson = tourData.pricing.per_person;
  const packagePerPerson = tourData.pricing.stored_totals;

  switch (packageType) {
    case "basic":
      return packagePerPerson?.total_price_basic || perPerson?.adult || 0;
    case "standard":
      return packagePerPerson?.total_price_standard || perPerson?.adult || 0;
    case "premium":
      return packagePerPerson?.total_price_premium || perPerson?.adult || 0;
    default:
      return packagePerPerson?.total_price_basic || 0;
  }
};

// 🔥 STEP 2 — CALCULATE PRICE WITHOUT ANY API CALL
const handlePrice = () => {
  // count travellers
  const adults = travellers.filter(t => t.type === "adult").length;
  const children = travellers.filter(t => t.type === "child").length;
  const infants = travellers.filter(t => t.type === "infant").length;

  // base price from selected package type
  const baseAdultPrice = getBasePrice();

  const childPrice = baseAdultPrice * 1;   // your logic
  const infantPrice = baseAdultPrice * 0;  // your logic

  // per person total (no days yet)
  let travellerTotal =
    adults * baseAdultPrice +
    children * childPrice +
    infants * infantPrice;

  // 🔥 APPLY PER-DAY MULTIPLICATION ONLY FOR TRIP TYPE 3
  let totalDays = 1;

  if (tourData?.trip_type_id === 3) {
    totalDays = calculateNights(startDate, endDate);
    travellerTotal = travellerTotal * totalDays;  // 🔥 multiply
  }

  // save base total
  setTourOnlyPrice(travellerTotal);

  const finalTotal = travellerTotal + calculateActivityTotal();

  setTotalPrice(finalTotal);

  return finalTotal;
};




  useEffect(() => {
    if (tourData?.id) {
      handlePrice();
    }
  }, [travellers, packageType]);
  // 🔥 Recalculate price when start or end date changes (ONLY FOR trip_type_id = 3)
useEffect(() => {
  if (tourData?.trip_type_id === 3) {
    handlePrice();
  }
}, [startDate, endDate]);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const days = calculateNights(startDate, endDate);
    const totalDays = tourData?.no_of_days || itininerary.length;
    const TourStart = dayjs(startDate).format("YYYY/MM/DD");
    const TourEnd = dayjs(endDate).format("YYYY/MM/DD");

    const computedPrice = await handlePrice();
    if (!computedPrice) {
      setLoading(false);
      return;
    }

    if (tourData?.trip_type_id === 3) {
      if (!TourStart || !TourEnd) {
        showToast("Please select both start and end dates", "warning");
        setLoading(false);
        return;
      }
      if (days <= totalDays) {
        showToast(
          `Please select dates matching the tour duration (${totalDays} days)`,
          "warning"
        );
        setLoading(false);
        return;
      }
    }

    const activityTotal = calculateActivityTotal();

const payload = {
  tour_id: tourData?.id,
  seats: travellers.length,
  customer_id: customer_data.id,
  total_amount: computedPrice + activityTotal,
  meta: {
    package_type: packageType,
    activities: seatCounts,
  },

// 🔥 HANDLE DIFFERENT TRIP TYPES
...(tourData?.trip_type_id === 1 || tourData?.trip_type_id === 5 || tourData?.trip_type_id === 2
  ? { group_departure_dates_input: selectedDate }
  : {}),

...(tourData?.trip_type_id === 3
  ? {
      tour_start_date: dayjs(startDate).format("YYYY-MM-DD"),
      tour_end_date: dayjs(endDate).format("YYYY-MM-DD"),
    }
  : {}),


  passengers: travellers.map((t) => ({
    name: t.name,
    age: t.age,
    type: t.type,
  })),
};


    console.log("Final Booking Payload:", payload);

    try {
      const res = await api.post("/bookings/tour", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (res?.data?.status === true) {
        showToast(`${res?.data?.message}`, "success");
        navigate(`/tour-review/${res?.data?.data?.tour_id}`, {
          state: { bookingDetails: res?.data?.data },
        });
        handleClose();
      }
    } catch (err) {
      console.error("Booking error:", err);
      showToast(err?.response?.data?.message || "Booking failed", "error");
    } finally {
      setLoading(false);
    }
  };

  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);


  console.log("activitys:", activities);
  const [seatCounts, setSeatCounts] = useState({});

  const calculateActivityTotal = () => {
    return activities.reduce((total, activity) => {
      const qty = seatCounts[activity.id] || 0;
      return total + qty * activity.price;
    }, 0);
  };

  const handleAddClick = (id) => {
    setSeatCounts((prev) => ({
      ...prev,
      [id]: prev[id] ? prev[id] + 1 : 1,
    }));
  };

  const handleRemoveClick = (id) => {
    setSeatCounts((prev) => ({
      ...prev,
      [id]: prev[id] > 1 ? prev[id] - 1 : 0,
    }));
  };
  useEffect(() => {
    setTotalPrice(tourOnlyPrice + calculateActivityTotal());
  }, [seatCounts, tourOnlyPrice]);


  const activitySlider = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 3,       // default for large screens
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1024, // <= 1024px
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
        }
      },
      {
        breakpoint: 768, // <= 768px
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };



  // Akash





  return (
    <>
      <div style={{ backgroundColor: "#f0f0f0" }}>
        <Navber />
      </div>

      {/* Booking Modal */}
      <Modal
        open={showPrice}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 300,
            sx: { backgroundColor: "rgba(0,0,0,0.5)" },
          },
        }}
      >
        <Fade in={showPrice}>
          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "92%", sm: 500 },
              bgcolor: "background.paper",
              borderRadius: 2,
              boxShadow: 24,
              p: { xs: 2, sm: 4 },
              maxHeight: "90vh",
              overflowY: "auto",
            }}
          >
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="h6">Booking Details</Typography>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Box>
            {tourData?.trip_type_id !== 5 && (
              <>
                <Typography variant="subtitle1" sx={{ mt: 2 }}>
                  Package Type
                </Typography>
                <RadioGroup
                  row
                  value={packageType}
                  onChange={(e) => setPackageType(e.target.value)}
                  sx={{ mb: 2 }}
                >
                  <FormControlLabel value="basic" control={<Radio />} label="Basic" />
                  <FormControlLabel value="standard" control={<Radio />} label="Standard" />
                  <FormControlLabel value="premium" control={<Radio />} label="Premium" />
                </RadioGroup>
              </>

            )}

            {/* DATE PICKER FOR TRIP TYPE 3 → Start & End Date */}
{tourData?.trip_type_id === 3 && (
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <Box sx={{ mb: 3 }}>
      <Typography variant="subtitle1">Select Start Date</Typography>

      <DatePicker
        label="Start Date"
        value={startDate}
        onChange={(newValue) => setStartDate(newValue)}
        minDate={dayjs().add(1, "day")}
      />

      <Typography variant="subtitle1" sx={{ mt: 2 }}>
        Select End Date
      </Typography>

      <DatePicker
        label="End Date"
        value={endDate}
        onChange={(newValue) => setEndDate(newValue)}
        minDate={startDate}
        disabled={!startDate}
      />
    </Box>
  </LocalizationProvider>
)}




{/* MULTIPLE DATE SELECTOR FOR TRIP ID 1 & 5 */}
{(tourData?.trip_type_id === 1 || tourData?.trip_type_id === 5 ||tourData?.trip_type_id === 2) && (
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <Box sx={{ mb: 3 }}>
      <Typography variant="subtitle1" sx={{ mb: 1 }}>
        Select Departure Date
      </Typography>

<DateCalendar
  value={selectedDate ? dayjs(selectedDate) : null}
  onChange={(newValue) => {
    const formatted = dayjs(newValue).format("YYYY-MM-DD");
    if (availableDates.includes(formatted)) {
      setSelectedDate(formatted); // ✔ only select this single date
    }
  }}
  slots={{
    day: (props) => {
      const formatted = dayjs(props.day).format("YYYY-MM-DD");
      const isAvailable = availableDates.includes(formatted);
      const isSelected = formatted === selectedDate;

      return (
        <CustomDay
          {...props}
          disabled={!isAvailable}        // ❌ disable non-departure dates
          isAvailable={isAvailable}      // ✔ show green dots
          isSelected={isSelected}        // ✔ highlight selected date
        />
      );
    },
  }}
/>


      {groupDepartureDates.length > 0 && (
        <Box sx={{ mt: 1 }}>
          <Typography variant="subtitle1">Selected Dates:</Typography>
          {groupDepartureDates.map((d, i) => (
            <Typography key={i}>• {dayjs(d).format("DD MMM YYYY")}</Typography>
          ))}
        </Box>
      )}
    </Box>
  </LocalizationProvider>
)}



            

            <Typography sx={{ mt: 1 }} color="text.primary">
              Activity Price: ₹{calculateActivityTotal()}
            </Typography>


            {/* Travellers */}
            <Typography variant="subtitle1" sx={{ mb: 1 }}>
              Travellers
            </Typography>
            {travellers.map((trav, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  gap: 2,
                  mb: 2,
                  alignItems: "center",
                  border: "1px solid #ddd",
                  p: 2,
                  borderRadius: 2,
                }}
              >
                <TextField
                  label="Name"
                  value={trav.name}
                  onChange={(e) =>
                    handleTravellerChange(index, "name", e.target.value)
                  }
                  fullWidth
                  required
                />
                <TextField
                  label="Age"
                  type="number"
                  value={trav.age}
                  onChange={(e) =>
                    handleTravellerChange(index, "age", e.target.value)
                  }
                  fullWidth
                  required
                />
                <TextField
                  select
                  label="Type"
                  value={trav.type}
                  onChange={(e) =>
                    handleTravellerChange(index, "type", e.target.value)
                  }
                  fullWidth
                >
                  <MenuItem value="adult">Adult</MenuItem>
                  <MenuItem value="child">Child</MenuItem>
                  <MenuItem value="infant">Infant</MenuItem>
                </TextField>
                {travellers.length > 1 && (
                  <IconButton color="error" onClick={() => handleRemoveTraveller(index)}>
                    <RemoveIcon />
                  </IconButton>
                )}
              </Box>
            ))}

            <Button
              variant="outlined"
              startIcon={<AddIcon />}
              onClick={handleAddTraveller}
              sx={{ mb: 3 }}
            >
              Add Traveller
            </Button>

            <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
              <Typography variant="h6">Total: ₹{totalPrice || tourData?.pricing?.stored_totals?.total_price_basic || tourData?.pricing?.per_person?.adult}</Typography>
              <Button type="submit" variant="contained" color="success">
                {loading ? <CircularProgress size={22} /> : "Confirm Booking"}
              </Button>
            </Box>
          </Box>
        </Fade>
      </Modal>



      {/* --- MAIN CONTENT BELOW --- */}
      <div className="travel-card">
        <div className="travel-card-image">
          <Slider {...settings}>
            {tourData?.destination?.gallery_photos?.map((imgSrc, index) => (
              <div key={index}>
                <img src={imgSrc} alt={`tour-${index}`} className="travel-card-image_img" />
              </div>
            ))}
          </Slider>

          <h3 style={{ marginTop: "30px", fontSize: "2rem" }}>Services</h3>
          <div
            style={{ display: "flex", justifyContent: "center" }}
            className="service_icons"
          >
            {[{ img: Building, label: "Hotel" },
            { img: Van, label: "Transport" },
            { img: Cablecar, label: "Activity" },
            { img: NavigationArrow, label: "Itinerary" }].map((item, i) => (
              <span
                key={i}
                style={{
                  width: "70px",
                  height: "70px",
                  borderRadius: "50%",
                  padding: "20px",
                  backgroundColor: "black",
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                  alignItems: "center",
                  fontWeight: "600",
                  color: "white",
                }}
              >
                <img src={item.img} height="100%" width="100%" />
                <span>{item.label}</span>
              </span>
            ))}
          </div>







        </div>

        {/* RIGHT CONTENT */}
        <div className="travel-card-content">
          <h2 className="travel-title">{tourData?.name}</h2>
          <p className="travel-description">
            <SafeComponent html={tourData?.destination?.description} />
          </p>
          <div style={{ display: "flex", alignItems: "center", gap: "2px" }}><h3 className="travel-price">₹{tourData?.pricing?.stored_totals?.total_price_basic || tourData?.pricing?.per_person?.adult}</h3><span>/adult</span>
          </div>

          <div className="travel-info">
            <div className="travel-info-item">
              <div className="travel-info-left" id="travel-info-left-mobile">
                <FaClock className="travel-icon" />
                <span style={{ marginLeft: "12px" }}>
                  {tourData?.no_of_days || "0"} days
                </span>
              </div>
              <button
                className="travel-btn travel-btn-primary"
                onClick={() => setShowPrice(true)}
              >
                Book Now
              </button>
              <button
                className="travel-btn travel-btn-primary"
                onClick={() => {
                  isBookmarked(tourData?.id) ? removeBookmark(tourData?.id) : addBookmark(tourData)
                }}
              >
                {isBookmarked(tourData?.id) ? "Remove Bookmark" : "Add to Bookmark"}
              </button>
            </div>
          </div>

          <hr />

          {/* Itinerary Accordion */}
          <div className="day-accordion">
            {itininerary.map((item, index) => (
              <div key={index} className="day-item">
                <div className="day-header" onClick={() => toggleDay(index)}>
                  <span>{item.name}</span>
                  {activeIndex === index ? (
                    <FaChevronUp className="day-icon" />
                  ) : (
                    <FaChevronDown className="day-icon" />
                  )}
                </div>
                {activeIndex === index && (
                  <div className="day-content">
                    <p>
                      <SafeComponent html={item?.description} />
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Map */}
          <div
            style={{
              width: "100%",
              margin: "0 auto",
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
            }}
          >
            <h3 style={{ padding: "4px" }}>View In map</h3>
            <SafeMap mapHtml={tourData?.destination?.map} />
          </div>
        </div>
      </div>

      {/* Activities */}
      <div className="activity-slider-container">
        <h3 className="activity-slider-title">Add Popular Activities</h3>

        <Slider {...activitySlider}>
          {activities.map((activity) => (
            <div className="activity-card" key={activity.id}>
              <div className="activity-card-img-wrapper">
                <img
                  src={activity.image_url}
                  alt={activity.name}
                  className="activity-card-img"
                />
                <div className="activity-card-overlay">
                  <h3 className="activity-card-name">{activity.name}</h3>
                  <p className="activity-card-price">₹{activity.price}</p>
                </div>
              </div>

              <div className="activity-card-footer">
                {seatCounts[activity.id] > 0 ? (
                  <div className="seat-counter">
                    <button
                      className="seat-btn"
                      onClick={() => handleRemoveClick(activity.id)}
                    >
                      –
                    </button>
                    <span>{seatCounts[activity.id]}</span>
                    <button
                      className="seat-btn"
                      onClick={() => handleAddClick(activity.id)}
                    >
                      +
                    </button>
                  </div>
                ) : (
                  <button
                    className="activity-add-btn"
                    onClick={() => handleAddClick(activity.id)}
                  >
                    Add
                  </button>
                )}
              </div>
            </div>
          ))}
        </Slider>
      </div>

      {/* <Travelers_favorite /> */}
      <User_Destinations />
      <Typemsg />
      <Why_travel_with_us />
    </>
  );
};

export default TourOverview;
